/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CurrencyCreateRequest,
  CurrencyResponse,
  CurrencyUpdateRequest,
  ProblemDetails,
  ProductCreateRequest,
  TenantCreateRequest,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class ClosedApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyUpdate
   * @summary Update an existing active currency
   * @request PUT:/closed-api/v1/currency/{code}
   * @secure
   * @response `200` `CurrencyResponse` Success
   */
  currencyUpdate = (code: string, data: CurrencyUpdateRequest, params: RequestParams = {}) =>
    this.request<CurrencyResponse, any>({
      path: `/closed-api/v1/currency/${code}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyDelete
   * @summary Delete an existing active currency
   * @request DELETE:/closed-api/v1/currency/{code}
   * @secure
   * @response `200` `File` Success
   */
  currencyDelete = (code: string, params: RequestParams = {}) =>
    this.request<File, any>({
      path: `/closed-api/v1/currency/${code}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Currency
   * @name CurrencyAdd
   * @summary Create a new currency
   * @request POST:/closed-api/v1/currency
   * @secure
   * @response `200` `object`
   */
  currencyAdd = <T,>(data: CurrencyCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/closed-api/v1/currency`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Product
   * @name ProductUpdate
   * @summary Update an existing active product
   * @request PUT:/closed-api/v1/product/{id}
   * @secure
   * @response `204` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  productUpdate = (id: string, data: ProductCreateRequest, params: RequestParams = {}) =>
    this.request<void, ProblemDetails>({
      path: `/closed-api/v1/product/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Product
   * @name ProductDelete
   * @summary Delete an existing active product
   * @request DELETE:/closed-api/v1/product/{id}
   * @secure
   * @response `200` `void` Success
   * @response `400` `ProblemDetails`
   * @response `404` `ProblemDetails`
   * @response `default` `ProblemDetails`
   */
  productDelete = (
    id: string,
    query: {
      /**
       * unique id of the product
       * @format guid
       */
      productId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails>({
      path: `/closed-api/v1/product/${id}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Product
   * @name ProductCreate
   * @summary Create a new product
   * @request POST:/closed-api/v1/product
   * @secure
   * @response `200` `object`
   */
  productCreate = <T,>(data: ProductCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/closed-api/v1/product`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetActiveUserSubscriptions
   * @summary Get a list of active users and their newsletter subscription status
   * @request GET:/closed-api/v1/reports/active-user-subscriptions
   * @secure
   * @response `200` `object`
   */
  reportsGetActiveUserSubscriptions = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/closed-api/v1/reports/active-user-subscriptions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Reports
   * @name ReportsGetBidsForNotSoldListings
   * @summary Get a bids for listings in the EndedNotSold state in the last 30 days
   * @request GET:/closed-api/v1/reports/bids-for-not-sold-listings
   * @secure
   * @response `200` `object`
   */
  reportsGetBidsForNotSoldListings = <T,>(params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/closed-api/v1/reports/bids-for-not-sold-listings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name TenantFindAll
   * @summary Get list of all tenants
   * @request GET:/closed-api/v1/tenant
   * @secure
   * @response `200` `object`
   */
  tenantFindAll = <T,>(
    query: {
      /** whether to include inactive tenants */
      includeInactive: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<T, any>({
      path: `/closed-api/v1/tenant`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Tenant
   * @name TenantCreate
   * @summary Create a new tenant
   * @request POST:/closed-api/v1/tenant
   * @secure
   * @response `200` `object`
   */
  tenantCreate = <T,>(data: TenantCreateRequest, params: RequestParams = {}) =>
    this.request<T, any>({
      path: `/closed-api/v1/tenant`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
